export default __webpack_public_path__ + "static/cohorte-a5c24515adea6416ff982f661826381e.png";